import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { take } from 'rxjs';
import { COTISATION_PERIODE_OPTIONS } from '../../subscription-form.utils';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'contigency-informations',
    templateUrl: './contigency-informations.component.html',
    styleUrls: ['./contigency-informations.component.scss'],
    standalone: false
})
export class ContigencyInformationsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  parameters;
  cotisationPeriodeOptions = COTISATION_PERIODE_OPTIONS;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.parameters = pledge?.parameters;
    this.subscriptionFacade.initForm(this, { ...this.parameters });
  }

  onSubmit() {
    const pledge = this.subscriptionFacade.getPledge();
    const params = this.products?.get('0')?.get('parameters')?.value;
    const productParams = pledge?.products?.[0]?.parameters;
    const devisId = productParams?.devisRecommandeId;

    if (pledge && params && devisId) {
      const body = {
        productId: pledge.products?.[0]?.productId,
        ownerId: pledge.owners?.[0]?.ownerId || pledge.owners?.[0]?.id,
        cotisation: params.monthlyPayment != null && params.monthlyPayment !== '' ? Number(params.monthlyPayment) : undefined,
        cotisationPeriode: params.cotisationPeriode,
      };
      this.productDao.updatePrevoyanceDevis(Number(pledge.accountId), devisId, body)
        .pipe(take(1))
        .subscribe({ error: () => this.notificationService.error('La mise à jour du devis prévoyance a échoué') });
    }
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
